import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "style1 header1" }

export function render(_ctx, _cache) {
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      gutter: 1,
      type: "flex",
      align: "middle",
      style: {"height":"100%","margin":"0"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              type: "flex",
              align: "middle"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "style2" }, " 管理后台 ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            false
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  type: "flex",
                  align: "middle",
                  class: "search"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("input", {
                      placeholder: "搜索点什么？",
                      class: "searchInput"
                    }, null, -1),
                    _createElementVNode("i", { class: "el-icon-search searchIcon" }, null, -1)
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              type: "flex",
              justify: "end",
              align: "middle",
              style: {"padding-right":"20px"}
            }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "iconView" }, [
                  _createTextVNode(" 你好， "),
                  _createElementVNode("span", { style: {"color":"white"} }, "管理员")
                ], -1)),
                _createVNode(_component_el_dropdown, { style: {"margin-left":"50px"} }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, {
                          onClick: _ctx.logOut,
                          divided: ""
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("退出登录")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      src: "12312313",
                      fit: "cover",
                      class: "style4"
                    }, {
                      error: _withCtx(() => [
                        _createVNode(_component_el_avatar, null, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode("管")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}